import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const RecentlyRegisteredCard = () => {
  const registered = [
    {
      name: "Pitch",
      plan: "Basic (Monthly)",
      users: "150 Users",
      domain: "pitch.example.com",
      img: "/assets/img/icons/company-icon-11.svg",
    },
    {
      name: "Initech",
      plan: "Enterprise (Yearly)",
      users: "200 Users",
      domain: "initech.example.com",
      img: "/assets/img/icons/company-icon-12.svg",
    },
    {
      name: "Umbrella Corp",
      plan: "Advanced (Monthly)",
      users: "129 Users",
      domain: "umbcorp.example.com",
      img: "/assets/img/icons/company-icon-13.svg",
    },
    {
      name: "Capital Partners",
      plan: "Enterprise (Monthly)",
      users: "103 Users",
      domain: "capitalpart.example.com",
      img: "/assets/img/icons/company-icon-14.svg",
    },
    {
      name: "Massive Dynamic",
      plan: "Premium (Yearly)",
      users: "108 Users",
      domain: "msdynamic.example.com",
      img: "/assets/img/icons/company-icon-15.svg",
    },
  ];

  return (
    <Card className="shadow-sm border-0 d-flex flex-column h-100 m-0">
      <Card.Header className="bg-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0 fw-semibold">Recently Registered</h5>
    
        
                <Link to="/recent-transactions" className="text-decoration-none"  >
                     <Button variant="light" size="sm">
          View All
        </Button>
                </Link>
      </Card.Header>

      <Card.Body className="flex-grow-1">
        {registered.map((item, i) => (
          <div
            key={i}
            className="d-flex justify-content-between align-items-center mb-3"
          >
            <div className="d-flex align-items-center">
              <div className="bg-light rounded-circle p-2 me-3">
                <img src={item.img} alt="" width="32" />
              </div>
              <div>
                <h6 className="mb-1 fw-semibold">{item.name}</h6>
                <small className="text-muted">{item.plan}</small>
              </div>
            </div>

            <div className="text-end">
              <small className="d-block">{item.users}</small>
              <small className="text-muted">{item.domain}</small>
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default RecentlyRegisteredCard;
